module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "FirstLayer",
    class: {
      "Bulletpoint": _vm.itemValues.bulletPoint, "Pagebreak": _vm.itemValues.pageBreak
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.itemValues.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.itemValues.price))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.itemValues.time))]), _vm._v(" "), _c('ul', [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b81bb3d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/FirstLayer.vue
// module id = 159
// module chunks = 4